import SyntheseEntityCtrlAcquereurController from './syntheseentities.ctrlacquereur.controller';

export default {
    template: require('./syntheseentities.ctrlacquereur.html'),
    controller: SyntheseEntityCtrlAcquereurController
};
